export default __webpack_public_path__ + "static/media/login.4ed70d0e.png";